module.exports = __webpack_public_path__ + "media/burp.14d9a81f.wav";